import React, { useCallback, useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import { fetchAllQuotations } from "../../../../../store/slices/generateQuotationSlice";
import { fetchHardwareDescriptions } from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchOtherExpenses } from "../../../../../store/slices/otherexpenses";
import { fetchSalesTaxes } from "../../../../../store/slices/salesTaxesSlice";
import { replaceProjectFinanceNotes } from "../../../../../store/slices/projectFinanceNotesSlice";
import { useSnackbar } from "notistack";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import {
    parseAmountNumber,
    formatAmountComma,
} from "../../../../../utils/decimalAmountUtils";
import {
    filterInstallationAssociatedExpenseEntriesForAggregation,
    getInstallationActualTrainingDisplayAmount,
    isTrainingExpenseDisplayRow,
    sumInstallationAssociatedTrainingValues,
} from "../../../../../utils/trainingOtherExpenseSync";
// import { updateProjectQuotedValue } from "../../../../../store/slices/changeQuotedValueforServiceSlice";
const ActualAllServiceTable = ({
    handlerefresh,
    filteredQuotation,
    // showAssociatedCostTable,
    selectedProject,
    projects,
    calculatedProjects,
    handleAccociatedTabClick,
    setinstallationPersons,
    setSoftwarePersons,
    setCloudPersons,
    setHardwarePersons,
    tasks,
    items,
    onTotalCostPerServiceTotalChange,
    getInstallationPerdiemAndAverageCost,
}) => {

    console.log("Dgdfg", filteredQuotation);
    const dispatch = useDispatch();
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();
    const formatMoneyComma = formatAmountComma;
    const formatHours = (value) =>
        new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
        }).format(Number(value) || 0);
    const { enqueueSnackbar } = useSnackbar();
    // const { quotations } = useSelector((state) => state.hourlyRateQuotation);
    const { employees } = useSelector((state) => state.employees);
    const { mytrainings } = useSelector((state) => state.myTrainings);
    const { taxes } = useSelector((state) => state.salesTaxes);
    const normalize = useCallback((v) => (v ?? "").toString().trim().toLowerCase(), []);

    const findProjectRowById = useCallback(
        (projectId) => {
            if (!projectId) return null;
            const id = String(projectId).trim();
            return (projects || []).find(
                (p) => String(p._id || p.ProjectID || "").trim() === id
            );
        },
        [projects]
    );

    /** Actual P&L: manager/operations rates from project slice (non-hardware). */
    const getProjectSliceHourlyRate = useCallback(
        (projectId, typeService, roles) => {
            const typeNorm = normalize(typeService);
            if (typeNorm.includes("hardware")) return 0;

            const projectRow = findProjectRowById(projectId);
            if (!projectRow) return 0;

            const primaryRole = Array.isArray(roles) ? roles[0] : roles;
            const roleNorm = normalize(primaryRole);
            const isManager =
                roleNorm.includes("manager") ||
                roleNorm.includes("project manager") ||
                roleNorm === "pm";

            if (isManager) {
                return Number(projectRow.managerHourlyRate) || 0;
            }
            return Number(projectRow.operationHourlyRate) || 0;
        },
        [findProjectRowById, normalize]
    );

    const [GandATax, setGandATax] = useState(15);
    const [taxValue, setTaxValue] = useState(27);
    const [selected, setSelected] = useState(false);
    const [totalServiceGrandTotal, setTotalServiceGrandTotal] = useState(0);
    const lastEmittedTotalCostPerServiceRef = useRef(null);
    const tableContainerRef = useRef(null);
    const [totalGrossProfit, setTotalGrossProfit] = useState(0);
    const [totalGAExpenses, setTotalGAExpenses] = useState(0);
    const [totalTax, setTotalTax] = useState(0);
    const [totalNetRevenue, setTotalNetRevenue] = useState(0);
    const [netRevenuePercentage, setNetRevenuePercentage] = useState(0);
    const [totalHoursSum, setTotalHoursSum] = useState(0);
    const [saveTimeout, setSaveTimeout] = useState({});
    const [notes, setNotes] = useState({});

    useEffect(() => {
        dispatch(fetchDescriptionTasks());
        dispatch(fetchAllQuotations());
        dispatch(fetchHardwareDescriptions());
        dispatch(fetchOtherExpenses());
        dispatch(fetchSalesTaxes());
    }, [dispatch]);

    useEffect(() => {
        taxes?.forEach((data) => {
            if (data.taxName === "G&A Expenses") {
                setGandATax(data.taxPercentage);
            } else if (data.taxName === "Tax") {
                setTaxValue(data.taxPercentage);
            }
        });
    }, [taxes]);

    const getMyTrainingAmountForAssignee = useMemo(() => {
        const trainingsList = Array.isArray(mytrainings?.trainings)
            ? mytrainings.trainings
            : Array.isArray(mytrainings)
                ? mytrainings
                : [];

        const resolveRefId = (ref) => {
            if (ref == null || ref === "") return "";
            if (typeof ref === "object") return String(ref?._id ?? ref?.id ?? "").trim();
            return String(ref).trim();
        };

        return (project, assigneeId) => {
            if (!project || !assigneeId) return 0;
            const assignee = resolveRefId(assigneeId);
            if (!assignee) return 0;

            const projectId = String(project?._id || project?.ProjectID || "").trim().toLowerCase();
            const quotationId = String(project?.quotationId || project?.quotationID || project?.quotationid || "").trim();
            const projectName = String(project?.ProjectName || project?.projectname || "").trim().toLowerCase();
            const leadId = String(project?.leadid || project?.leadId || project?.LeadId || project?.LeadID || "").trim();

            const matched = trainingsList.filter((t) => {
                const assignedTo = resolveRefId(t?.assignedto ?? t?.assignedTo);
                if (!assignedTo || assignedTo !== assignee) return false;

                const tProjectId = resolveRefId(t?.projectid ?? t?.projectId ?? t?.project).toLowerCase();
                const tQuotationId = String(t?.quotationId ?? t?.quotationID ?? t?.quotationid ?? "").trim();
                const tProjectName = String(t?.projectname || "").trim().toLowerCase();
                const tLeadId = String(t?.leadid ?? t?.leadId ?? "").trim();

                return (
                    (projectId && tProjectId && projectId === tProjectId) ||
                    (quotationId && tQuotationId && quotationId === tQuotationId) ||
                    (projectName && tProjectName && projectName === tProjectName) ||
                    (leadId && tLeadId && leadId === tLeadId)
                );
            });

            return matched.reduce((sum, t) => {
                const amount = Number(
                    String(t?.trainingcost ?? t?.trainingCost ?? 0)
                        .toString()
                        .replace(/,/g, "")
                );
                return sum + (Number.isFinite(amount) ? amount : 0);
            }, 0);
        };
    }, [mytrainings]);

    // Function to get description values for a specific project and person
    const getDescriptionValues = useCallback(
        (projectID, personID, typeService) => {
            if (!tasks) return [];
            const normalizedProjectId = String(projectID || "").trim();
            const normalizedPersonId = String(personID || "").trim();
            return tasks.filter((desc) => {
                const descProjectId = String(desc?.projectid || "").trim();
                const descTaskOwnerId = String(desc?.taskownerid || "").trim();
                if (!(descProjectId === normalizedProjectId && descTaskOwnerId === normalizedPersonId)) return false;
                if (isTrainingExpenseDisplayRow(desc)) return false;
                if (!typeService) return true;
                const descTypeService = String(desc?.typeservice || "").trim().toLowerCase();
                if (!descTypeService) return true;
                return descTypeService === String(typeService).trim().toLowerCase();
            });
        },
        [tasks]
    );



    const getTotalDescriptionValue = useCallback(
        (projectID, personID, typeService) => {
            const typeNorm = String(typeService || "").trim().toLowerCase();

            // Installation: use locked perdiem/avgcost from Actual P&L parent (quoted snapshot).
            if (typeNorm.includes("installation")) {
                const descriptions = getDescriptionValues(projectID, personID, typeService);
                const lockedRates = getInstallationPerdiemAndAverageCost
                    ? getInstallationPerdiemAndAverageCost(projectID)
                    : null;
                const projectRow = findProjectRowById(projectID);
                const instPerdiem = lockedRates
                    ? Number(lockedRates.perdiem) || 0
                    : Number(projectRow?.perdiem) || 0;
                const instAveragecost = lockedRates
                    ? Number(lockedRates.averagecost) || 0
                    : Number(projectRow?.avgcost ?? projectRow?.averagecost) || 0;

                let descriptionValue = 0;
                filterInstallationAssociatedExpenseEntriesForAggregation(
                    descriptions
                ).forEach((entry) => {
                    if (isTrainingExpenseDisplayRow(entry)) return;
                    const amt = parseAmountNumber(
                        entry?.expenses ?? entry?.value ?? entry?.Value
                    );
                    if (amt) descriptionValue += amt;
                });

                let maxTripDuration = 0;
                descriptions.forEach((desc) => {
                    if (desc.tripduration) {
                        maxTripDuration = Math.max(
                            maxTripDuration,
                            Number(desc.tripduration) || 0
                        );
                    }
                });
                if (maxTripDuration > 0) {
                    descriptionValue +=
                        maxTripDuration * instPerdiem +
                        maxTripDuration * instAveragecost;
                }

                if (tasks && projectID && personID) {
                    const normalizedProjectId = String(projectID || "").trim();
                    const normalizedPersonId = String(personID || "").trim();
                    const assigneeEmp = (employees || []).find(
                        (e) => String(e?._id || "").trim() === normalizedPersonId
                    );
                    const installationEntries = (tasks || []).filter((desc) => {
                        const descProjectId = String(desc?.projectid || "").trim();
                        const descTaskOwnerId = String(desc?.taskownerid || "").trim();
                        if (
                            !(
                                descProjectId === normalizedProjectId &&
                                descTaskOwnerId === normalizedPersonId
                            )
                        ) {
                            return false;
                        }
                        const dst = String(desc?.typeservice || "")
                            .trim()
                            .toLowerCase();
                        if (!dst) return true;
                        return dst.includes("installation");
                    });
                    const instProjects = ([]).concat(projects || []).filter((p) => {
                        const ts = p?.TypeService;
                        if (!ts) return false;
                        if (Array.isArray(ts)) {
                            return ts.some((x) =>
                                String(x || "").toLowerCase().includes("installation")
                            );
                        }
                        return String(ts).toLowerCase().includes("installation");
                    });
                    descriptionValue += getInstallationActualTrainingDisplayAmount({
                        entries: installationEntries,
                        matchedProjects: instProjects.length
                            ? instProjects
                            : ([]).concat(projects || []),
                        assigneeEmp,
                        trainingsEnvelope: mytrainings,
                        projects: projects || [],
                        currencySymbol: currency,
                    });
                }

                return descriptionValue;
            }

            const descriptions = getDescriptionValues(projectID, personID, typeService);

            let descriptionValue = 0;
            descriptions.forEach((desc) => {
                // Match ActualFinaceTable / Itemized P&L: amount may be `expenses` or `value`
                const exp = parseAmountNumber(desc?.expenses ?? desc?.value);
                if (exp) descriptionValue += exp;
            });

            // Training rows from description tasks (same approach as Quoted AllServiceTable)
            if (tasks && projectID && personID) {
                const normalizedProjectId = String(projectID || "").trim();
                const normalizedPersonId = String(personID || "").trim();
                const normalizedTypeService = String(typeService || "").trim().toLowerCase();
                const trainingTasks = tasks.filter((desc) => {
                    const descProjectId = String(desc?.projectid || "").trim();
                    const descTaskOwnerId = String(desc?.taskownerid || "").trim();
                    if (!(descProjectId === normalizedProjectId && descTaskOwnerId === normalizedPersonId)) {
                        return false;
                    }
                    if (!isTrainingExpenseDisplayRow(desc)) return false;
                    if (!normalizedTypeService) return true;
                    const descTypeService = String(desc?.typeservice || "").trim().toLowerCase();
                    if (!descTypeService) return true;
                    return descTypeService === normalizedTypeService;
                });
                const trainingTotal = sumInstallationAssociatedTrainingValues(trainingTasks);

                descriptionValue += trainingTotal;
            }

            const projectCtx = {
                _id: projectID,
                ProjectID: projectID,
                ProjectName: selectedProject?.ProjectName,
                quotationId: selectedProject?.quotationId,
                leadid: selectedProject?.leadId ?? selectedProject?.leadid,
            };
            // For Actual P&L, Associated Cost should include trainings for BOTH manager and operations person.
            descriptionValue += getMyTrainingAmountForAssignee(projectCtx, personID);

            return descriptionValue;
        },
        [
            getDescriptionValues,
            findProjectRowById,
            getInstallationPerdiemAndAverageCost,
            tasks,
            employees,
            projects,
            mytrainings,
            currency,
            getMyTrainingAmountForAssignee,
            selectedProject,
        ]
    );

    const getHardwareValues = useCallback(
        (projectID, typeService) => {
            if (!items) return [];
            return items.filter(
                (desc) =>
                    desc.projectid === projectID &&
                    // desc.taskownerid === personID &&
                    desc.typeservice === typeService
            );
        },
        [items]
    );

    const getTotalHardwareCostValue = useCallback(
        (projectID, personID, typeService) => {
            // const hardwareCost = getHardwareValues(projectID, personID, typeService);
            let hardwareValue = 0;
            const hardwareCost = getHardwareValues(projectID, typeService);
            const hardwareByDescription = {};

            // Group hardware by assemblepartdescription and keep only the one with highest totalprice
            hardwareCost.forEach((hw) => {
                const description = hw.assemblepartdescription;

                if (!hardwareByDescription[description]) {
                    hardwareByDescription[description] = hw;
                } else {
                    // If we already have this description, keep the one with higher totalprice
                    if (hw.totalprice > hardwareByDescription[description].totalprice) {
                        hardwareByDescription[description] = hw;
                    }
                }
            });

            // Calculate total hardware value using only the highest totalprice items
            Object.values(hardwareByDescription).forEach((hw) => {
                if (hw.totalprice) {
                    hardwareValue += hw.totalprice;
                }
            });
            return hardwareValue
            // return hardwareCost.reduce((sum, desc) => sum + (desc.totalprice || 0), 0);
        },
        [getHardwareValues]
    );

    const [matchedDescription, setMatchedDescription] = useState(0);
    const [matchedHardware, setMatchedHardware] = useState(0);
    const [totalCostSum, setTotalCostSum] = useState("");
    // Function to generate calculation data
    const generateCalculationData = useCallback(() => {
        if (!filteredQuotation) return [];

        const data = [];

        Object.entries(filteredQuotation).forEach(([projectName, typeServices]) => {
            Object.entries(typeServices).forEach(([typeService, items]) => {
                items.forEach((item) => {
                    if (!item?.WorkEntries || item.WorkEntries.length === 0) return;

                    const groupedByPerson = {};
                    const personRoleMap = {};

                    // Group work entries by person
                    item.WorkEntries.forEach((entry) => {
                        const personName = entry?.createdBy?.name;
                        const personRoles = entry?.createdBy?.role || [];
                        const personId = entry?.taskownerid;

                        if (!groupedByPerson[personName]) {
                            groupedByPerson[personName] = {
                                totalHours: 0,
                                personId: personId,
                            };
                        }
                        groupedByPerson[personName].totalHours += entry.hoursspent || 0;

                        if (!personRoleMap[personName]) {
                            personRoleMap[personName] = {
                                roles: personRoles,
                                personId: personId,
                            };
                        }
                    });

                    // Create data objects for each person
                    Object.entries(groupedByPerson).forEach(([name, personData]) => {
                        const personId = personData.personId;
                        const totalHours = personData.totalHours;
                        const roles = personRoleMap[name]?.roles || [];

                        // Find employee details
                        const currentEmployee = employees.find((emp) => {
                            const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`
                                .trim()
                                .toLowerCase();
                            return fullName === name.trim().toLowerCase();
                        });

                        const capitalizedRoles =
                            currentEmployee?.customRoles?.map(
                                (role) =>
                                    role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
                            ) || [];

                        // Actual P&L: project slice managerHourlyRate / operationHourlyRate
                        const hourlyRate = item?.TypeService?.toLowerCase().includes("hardware")
                            ? 0
                            : getProjectSliceHourlyRate(
                                  item.ProjectID,
                                  item.TypeService,
                                  roles
                              );

                        // Total Efforts = Hours × Hourly Rate
                        const totalCost = totalHours * hourlyRate;

                        // Get description and hardware totals
                        const descriptionTotal = getTotalDescriptionValue(
                            item.ProjectID,
                            personId,
                            item.TypeService
                        );

                        const hardwareTotal = getTotalHardwareCostValue(
                            item.ProjectID,
                            personId,
                            item.TypeService
                        );

                        const personTotal = totalCost + descriptionTotal + hardwareTotal;

                        // Add to calculation data array
                        data.push({
                            projectName,
                            projectId: item.ProjectID,
                            typeService: item.TypeService,
                            personName: name,
                            personId,
                            designation: `${item.TypeService} ${capitalizedRoles[0] || " "}`,
                            hours: item?.TypeService?.toLowerCase().includes("hardware") ? 0 : totalHours,
                            // hours: item.TypeService === "Hardware" ? 0 : totalHours,
                            hourlyRate: item?.TypeService?.toLowerCase().includes("hardware") ? 0 : hourlyRate,
                            // hourlyRate: item.TypeService === "Hardware" ? 0 : hourlyRate,
                            effortCost: item?.TypeService?.toLowerCase().includes("hardware") ? 0 : totalCost,
                            // effortCost: item.TypeService === "Hardware" ? 0 : totalCost,
                            descriptionCost: item?.TypeService?.toLowerCase().includes("hardware") ? 0 : descriptionTotal,
                            // descriptionCost: item.TypeService === "Hardware" ? 0 : descriptionTotal,
                            hardwareCost: item?.TypeService?.toLowerCase().includes("hardware") ? hardwareTotal : 0,
                            // hardwareCost: item.TypeService === "Hardware" ? hardwareTotal : 0,
                            totalCost: personTotal
                        });
                    });
                });
            });
        });

        return data;
    }, [
        filteredQuotation,
        employees,
        getTotalDescriptionValue,
        getTotalHardwareCostValue,
        getProjectSliceHourlyRate,
    ]);

    // Update calculation data whenever filteredQuotation changes
    useEffect(() => {
        const data = generateCalculationData();

        const totalEffortCost = data.reduce((sum, item) => sum + (item.effortCost || 0), 0);
        setTotalCostSum(totalEffortCost);
    }, [filteredQuotation, generateCalculationData]);

    const allProjectsOnly = useMemo(() => {
        const ids = new Set();
        Object.values(filteredQuotation || {}).forEach((typeServices) => {
            Object.values(typeServices || {}).forEach((serviceItems) => {
                (serviceItems || []).forEach((item) => {
                    if (item?.ProjectID) ids.add(item.ProjectID);
                });
            });
        });
        return Array.from(ids);
    }, [filteredQuotation]);

    useEffect(() => {
        if (allProjectsOnly?.length && items?.length) {
            const matchedHardwareItems = items.filter((item) =>
                allProjectsOnly.includes(item.projectid)
            );

            // Group hardware by assemblepartdescription and keep only the one with highest totalprice
            const hardwareByDescription = {};
            matchedHardwareItems.forEach((hw) => {
                const description = hw.assemblepartdescription;

                if (!hardwareByDescription[description]) {
                    hardwareByDescription[description] = hw;
                } else {
                    // If we already have this description, keep the one with higher totalprice
                    if (hw.totalprice > hardwareByDescription[description].totalprice) {
                        hardwareByDescription[description] = hw;
                    }
                }
            });

            // Calculate total hardware value using only the highest totalprice items
            const totalHardwareValue = Object.values(hardwareByDescription).reduce(
                (sum, hw) => sum + (hw.totalprice || 0),
                0
            );

            setMatchedHardware(totalHardwareValue);
        }
    }, [allProjectsOnly, items]);



    const calculateGrossProfit = (ServiceQuotedValue, projectName, serviceGrandTotal, typeService, projectID) => {
        const quotedValuePerService = ServiceQuotedValue;
        const grossProfit = quotedValuePerService - serviceGrandTotal;
        return grossProfit;
    };

    const handleClick = () => {
        setSelected(!selected);
    };


    // const transformFilteredQuotation = useCallback((filteredQuotation, employees) => {

    //     const result = [];

    //     Object.entries(filteredQuotation || {}).forEach(([projectName, typeServices]) => {
    //         Object.entries(typeServices).forEach(([typeService, items]) => {
    //             items.forEach((item) => {
    //                 if (!item?.WorkEntries?.length) return;

    //                 // Group work entries by person
    //                 const groupedByPerson = {};
    //                 const personRoleMap = {};
    //                 item.WorkEntries.forEach((entry) => {
    //                     const personName = entry?.createdBy?.name;
    //                     const personRoles = entry?.createdBy?.role || [];
    //                     const personId = entry?.taskownerid;

    //                     if (!groupedByPerson[personName]) {
    //                         groupedByPerson[personName] = { totalHours: 0, personId };
    //                     }
    //                     groupedByPerson[personName].totalHours += entry.hoursspent || 0;

    //                     if (!personRoleMap[personName]) {
    //                         personRoleMap[personName] = { roles: personRoles, personId };
    //                     }
    //                 });

    //                 // Convert grouped persons into array with costs
    //                 Object.entries(groupedByPerson).forEach(([name, personData]) => {
    //                     const totalHours = personData.totalHours;
    //                     const personId = personData.personId;
    //                     const roles = personRoleMap[name]?.roles || [];
    //                     const ProjectID = item?.ProjectID;
    //                     const ProjectNotes = item?.ProjectNotes
    //                     const ServiceQuotedValue = item?.QuotedValue


    //                     const matchedQuotation = item?.quotationDetails?.find((q) =>
    //                         q.personid === personId
    //                     );

    //                     // If no direct personid match, fall back to role matching
    //                     const finalMatchedQuotation = matchedQuotation ||
    //                         item?.quotationDetails?.find((q) =>
    //                             roles.some((role) =>
    //                                 q.designation?.toLowerCase().includes(role?.toLowerCase())
    //                             )
    //                         );

    //                     // // Match quotation details
    //                     // const matchedQuotation = item?.quotationDetails?.find((q) =>
    //                     //     roles.some((role) =>
    //                     //         q.designation?.toLowerCase().includes(role?.toLowerCase())
    //                     //     )
    //                     // );

    //                     const currentEmployee = employees.find((emp) => {
    //                         const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`.trim().toLowerCase();
    //                         return fullName === name.trim().toLowerCase();
    //                     });

    //                     const capitalizedRoles =
    //                         currentEmployee?.customRoles?.map(
    //                             (role) =>
    //                                 role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
    //                         ) || [];

    //                     const hourlyRate =
    //                         (finalMatchedQuotation?.hourlysalaray || 0) +
    //                         (finalMatchedQuotation?.overheadpercentage || 0);

    //                     const totalCost = totalHours * hourlyRate;

    //                     // External helpers (you already have these)
    //                     const descriptionTotal = getTotalDescriptionValue(
    //                         item.ProjectID,
    //                         personId,
    //                         item.TypeService
    //                     );

    //                     const hardwareTotal = getTotalHardwareCostValue(
    //                         item.ProjectID,
    //                         personId,
    //                         item.TypeService
    //                     );
    //                     const hasProjectManagerRole = capitalizedRoles.includes("Project manager");
    //                     result.push({
    //                         ServiceQuotedValue,
    //                         projectName,
    //                         typeService: item.TypeService,
    //                         resourceType: item.ResourceType,
    //                         personId,
    //                         ProjectID,
    //                         ProjectNotes,
    //                         personName: name,
    //                         roles: capitalizedRoles,
    //                         totalHours,
    //                         hourlyRate,
    //                         totalCost,
    //                         descriptionTotal,
    //                         hardwareTotal,
    //                         // grandTotal:
    //                         //     item?.TypeService?.toLowerCase().includes("hardware")
    //                         //         // item.TypeService === "Hardware"
    //                         //         ? hardwareTotal + descriptionTotal
    //                         //         : descriptionTotal + totalCost,
    //                         grandTotal:
    //                             item?.TypeService?.toLowerCase().includes("hardware")
    //                                 ? (hasProjectManagerRole ? hardwareTotal : 0) + descriptionTotal
    //                                 : descriptionTotal + totalCost,
    //                     });
    //                 });
    //             });
    //         });
    //     });

    //     return result;
    // }, [getTotalDescriptionValue, getTotalHardwareCostValue]);

    const transformFilteredQuotation = useCallback((filteredQuotation, employees) => {
        const result = [];

        Object.entries(filteredQuotation || {}).forEach(([projectName, typeServices]) => {
            Object.entries(typeServices).forEach(([typeService, items]) => {
                items.forEach((item) => {
                    // Create a map to track all persons by their ID
                    const allPersonsMap = new Map();

                    // Helper to get employee by email
                    const getEmployeeByEmail = (email) => {
                        return employees.find(emp =>
                            emp.EmpEmail?.toLowerCase() === email?.toLowerCase()
                        );
                    };

                    // Helper to get employee by name
                    const getEmployeeByName = (name) => {
                        return employees.find(emp => {
                            const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`.toLowerCase();
                            return fullName === name?.toLowerCase();
                        });
                    };

                    // 1. Add persons from WorkEntries (these have actual hours worked)
                    if (item?.WorkEntries?.length) {
                        item.WorkEntries.forEach((entry) => {
                            const personName = entry?.createdBy?.name;
                            const personEmail = entry?.createdBy?.email;
                            const personId = entry?.taskownerid;
                            const personRoles = entry?.createdBy?.role || [];

                            if (!personId) return;

                            // Try to get employee by email first, then by name
                            let currentEmployee = personEmail
                                ? getEmployeeByEmail(personEmail)
                                : getEmployeeByName(personName);

                            // Use employee's ID if found, otherwise use the personId from work entry
                            const finalPersonId = currentEmployee?._id || personId;

                            // Get the person's name from employee data if available
                            const finalPersonName = currentEmployee
                                ? `${currentEmployee.EmpFirstName} ${currentEmployee.EmpLastName}`
                                : personName;

                            if (!allPersonsMap.has(finalPersonId)) {
                                allPersonsMap.set(finalPersonId, {
                                    personId: finalPersonId,
                                    personName: finalPersonName,
                                    email: personEmail || currentEmployee?.EmpEmail,
                                    totalHours: entry.hoursspent || 0,
                                    roles: currentEmployee?.customRoles || personRoles,
                                    fromWorkEntries: true,
                                    fromAssignedPerson: false
                                });
                            } else {
                                // Update hours if person already exists
                                const existing = allPersonsMap.get(finalPersonId);
                                existing.totalHours += entry.hoursspent || 0;
                            }
                        });
                    }

                    // 2. Add persons from Assignedperson who weren't in WorkEntries
                    if (item?.Assignedperson?.length) {
                        item.Assignedperson.forEach((assignedPerson) => {
                            const personName = assignedPerson.name;
                            const personEmail = assignedPerson.email;

                            if (!personEmail && !personName) return;

                            // Find employee by email first (more reliable)
                            let currentEmployee = personEmail
                                ? getEmployeeByEmail(personEmail)
                                : getEmployeeByName(personName);

                            if (!currentEmployee) {
                                console.warn(`Employee not found: ${personName} (${personEmail})`);
                                return;
                            }

                            const finalPersonId = currentEmployee._id;
                            const finalPersonName = `${currentEmployee.EmpFirstName} ${currentEmployee.EmpLastName}`;

                            // Only add if not already in map (from WorkEntries)
                            if (!allPersonsMap.has(finalPersonId)) {
                                allPersonsMap.set(finalPersonId, {
                                    personId: finalPersonId,
                                    personName: finalPersonName,
                                    email: currentEmployee.EmpEmail,
                                    totalHours: 0, // No hours from WorkEntries
                                    roles: currentEmployee.customRoles || [],
                                    fromWorkEntries: false,
                                    fromAssignedPerson: true
                                });
                            }
                        });
                    }

                    // Convert to array
                    const allPersons = Array.from(allPersonsMap.values());

                    if (allPersons.length === 0) return;

                    // Identify managers in this service
                    const managers = allPersons.filter(person =>
                        person.roles.some(role =>
                            role.toLowerCase().includes('manager') ||
                            role.toLowerCase().includes('pm')
                        )
                    );

                    const hasManager = managers.length > 0;
                    const isHardwareService = typeService?.toLowerCase().includes("hardware");

                    // Sort persons: managers first, then others (for consistent hardware assignment)
                    const sortedPersons = [...allPersons].sort((a, b) => {
                        const isManagerA = managers.includes(a);
                        const isManagerB = managers.includes(b);

                        if (isManagerA && !isManagerB) return -1;
                        if (!isManagerA && isManagerB) return 1;

                        // Both are managers or both are not managers - maintain original order
                        return 0;
                    });

                    // Track if hardware cost has been assigned for this service
                    let hardwareCostAssigned = false;

                    // Process each person
                    sortedPersons.forEach((person, index) => {
                        const isManager = managers.includes(person);

                        // Actual P&L: project slice managerHourlyRate / operationHourlyRate
                        let hourlyRate = 0;
                        if (!isHardwareService) {
                            hourlyRate = getProjectSliceHourlyRate(
                                item.ProjectID,
                                typeService,
                                person.roles
                            );
                        }

                        // For display purposes: Hardware services show 0 hourly rate
                        const displayHourlyRate = isHardwareService ? 0 : hourlyRate;

                        // Total Efforts = Hours × Hourly Rate (preserve decimals)
                        const totalCost = person.totalHours * hourlyRate;

                        // Get description and hardware totals
                        const descriptionTotal = getTotalDescriptionValue(
                            item.ProjectID,
                            person.personId,
                            typeService
                        );

                        const hardwareTotal = getTotalHardwareCostValue(
                            item.ProjectID,
                            person.personId,
                            typeService
                        );

                        // Calculate grand total based on service type and role
                        let grandTotal = 0;
                        let displayHardwareCost = 0; // For "Total Efforts" column

                        if (isHardwareService) {
                            // For hardware services
                            if (isManager) {
                                // Manager gets hardware + description
                                grandTotal = hardwareTotal + descriptionTotal;
                                displayHardwareCost = hardwareTotal;
                                hardwareCostAssigned = true;
                            } else if (!hasManager && !hardwareCostAssigned) {
                                // First non-manager gets hardware + description if no manager exists
                                grandTotal = hardwareTotal + descriptionTotal;
                                displayHardwareCost = hardwareTotal;
                                hardwareCostAssigned = true;
                            } else {
                                // Others get only description
                                grandTotal = descriptionTotal;
                                displayHardwareCost = 0;
                            }
                        } else {
                            // For non-hardware services (Software, Cloud, Installation)
                            grandTotal = totalCost + descriptionTotal;
                            displayHardwareCost = 0;
                        }

                        const isInstallationService = String(typeService || "")
                            .toLowerCase()
                            .includes("installation");
                        const installationRates = isInstallationService && getInstallationPerdiemAndAverageCost
                            ? getInstallationPerdiemAndAverageCost(item.ProjectID)
                            : null;

                        result.push({
                            ServiceQuotedValue: item.QuotedValue,
                            projectName,
                            typeService,
                            resourceType: item.ResourceType,
                            personId: person.personId,
                            ProjectID: item.ProjectID,
                            ProjectNotes: item.ProjectNotes,
                            personName: person.personName,
                            roles: person.roles.map(role =>
                                role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
                            ),
                            totalHours: person.totalHours,
                            hourlyRate: displayHourlyRate, // 0 for hardware, actual rate for others
                            actualHourlyRate: hourlyRate, // Actual rate for calculations
                            totalCost: totalCost, // hours * rate (for non-hardware)
                            displayHardwareCost: displayHardwareCost, // For hardware display in "Total Efforts" column
                            descriptionTotal,
                            hardwareTotal,
                            grandTotal,
                            isManager,
                            hasManagerInService: hasManager,
                            hardwareCostAssigned: hardwareCostAssigned && (isManager || (!hasManager && index === 0)),
                            fromWorkEntries: person.fromWorkEntries,
                            fromAssignedPerson: person.fromAssignedPerson,
                            email: person.email,
                            ...(installationRates
                                ? {
                                      installationPerdiemRate: installationRates.perdiem,
                                      installationAveragecostRate: installationRates.averagecost,
                                  }
                                : {}),
                        });

                        // Optional debug logging
                        if (isHardwareService) {
                            console.log("Hardware Person Processing:", {
                                personName: person.personName,
                                isManager,
                                hasManager,
                                hardwareTotal,
                                descriptionTotal,
                                grandTotal,
                                displayHardwareCost,
                                hardwareCostAssigned,
                                index
                            });
                        }
                    });
                });
            });
        });

        return result;
    }, [
        getTotalDescriptionValue,
        getTotalHardwareCostValue,
        getProjectSliceHourlyRate,
        getInstallationPerdiemAndAverageCost,
    ]);

    const groupByTypeService = (processedData) => {
        return processedData.reduce((acc, curr) => {
            if (!acc[curr.typeService]) {
                acc[curr.typeService] = [];
            }
            acc[curr.typeService].push(curr);
            return acc;
        }, {});
    };


    const processedData = useMemo(() => {
        return transformFilteredQuotation(filteredQuotation, employees);
    }, [filteredQuotation, employees, transformFilteredQuotation]);

    const groupedData = useMemo(() => {
        return groupByTypeService(processedData);
    }, [processedData]);

    // Same aggregation as per-service "Total Cost Per Service" column + footer (hardware manager rules included).
    const computeItemizedTotalCostPerService = useCallback((data) => {
        if (!data || Object.keys(data).length === 0) return 0;
        let sum = 0;
        Object.entries(data).forEach(([typeService, rows]) => {
            const isHardware = typeService?.toLowerCase().includes("hardware");
            const hasManager = rows.some((row) => {
                const role = row.roles[0]?.toLowerCase();
                return (
                    role?.includes("manager") ||
                    role?.includes("project manager") ||
                    role?.includes("pm")
                );
            });
            const serviceGrandTotal = rows.reduce((acc, row, idx) => {
                let rowGrandTotal = Number(row.grandTotal) || 0;
                if (isHardware && !hasManager && idx === 0) {
                    rowGrandTotal =
                        (Number(row.hardwareTotal) || 0) +
                        (Number(row.descriptionTotal) || 0);
                }
                return acc + rowGrandTotal;
            }, 0);
            sum += serviceGrandTotal;
        });
        return sum;
    }, []);

    const roundedTotalCostPerService = useMemo(
        () => Math.round(Number(totalServiceGrandTotal) || 0),
        [totalServiceGrandTotal]
    );

    // Footer "Associated Cost" total: match sum of per-resource Associated Cost in Itemized P&L (includes training).
    useEffect(() => {
        if (!groupedData || !Object.keys(groupedData).length) {
            setMatchedDescription(0);
            return;
        }
        let descriptionValue = 0;
        Object.values(groupedData).forEach((rows) => {
            (rows || []).forEach((row) => {
                descriptionValue += Number(row.descriptionTotal) || 0;
            });
        });
        setMatchedDescription(descriptionValue);
    }, [groupedData]);

    console.log("fgsgsdgs", groupedData);

    useEffect(() => {
        lastEmittedTotalCostPerServiceRef.current = null;
        setTotalServiceGrandTotal(0);
    }, [selectedProject?.quotationId, selectedProject?.ProjectName, selectedProject?._id, selectedProject?.id]);

    useEffect(() => {
        if (!groupedData || Object.keys(groupedData).length === 0) {
            setTotalServiceGrandTotal(0);
            return;
        }
        setTotalServiceGrandTotal(computeItemizedTotalCostPerService(groupedData));
    }, [groupedData, computeItemizedTotalCostPerService]);

    // Bubble up the Itemized P&L "Total Cost Per Service" total so the Actual P&L table
    // can display the same figure in the "Actual Expenses" column.
    useEffect(() => {
        const projectKey =
            selectedProject?.quotationId != null && String(selectedProject.quotationId).trim() !== ""
                ? String(selectedProject.quotationId).trim()
                : String(selectedProject?.ProjectName ?? "").trim();
        if (!projectKey) return;
        if (typeof onTotalCostPerServiceTotalChange !== "function") return;
        if (lastEmittedTotalCostPerServiceRef.current === roundedTotalCostPerService) return;
        lastEmittedTotalCostPerServiceRef.current = roundedTotalCostPerService;
        onTotalCostPerServiceTotalChange(projectKey, roundedTotalCostPerService);
    }, [
        selectedProject,
        roundedTotalCostPerService,
        onTotalCostPerServiceTotalChange,
    ]);

    useEffect(() => {
        if (selected && tableContainerRef.current) {
            // Scroll to the right end of the container
            const scrollToPosition = tableContainerRef.current.scrollWidth;
            tableContainerRef.current.scrollTo({
                left: scrollToPosition,
                behavior: 'smooth'
            });
        }
    }, [selected]);



    useEffect(() => {
        if (groupedData && Object.keys(groupedData).length > 0) {
            let serviceSum = 0;
            let grossProfitSum = 0;
            let gaExpensesSum = 0;
            // let ebitSum = 0;
            let taxSum = 0;
            let netRevenueSum = 0;

            Object.entries(groupedData).forEach(([typeService, rows]) => {
                const isHardware = typeService?.toLowerCase().includes("hardware");
                const hasManager = rows.some(row => {
                    const role = row.roles[0]?.toLowerCase();
                    return role?.includes("manager") || role?.includes("project manager") || role?.includes("pm");
                });

                const serviceGrandTotal = rows.reduce((acc, row, idx) => {
                    let rowGrandTotal = Number(row.grandTotal) || 0;

                    // If hardware, no manager, and this is the first employee, include hardwareTotal
                    if (isHardware && !hasManager && idx === 0) {
                        rowGrandTotal = (Number(row.hardwareTotal) || 0) + (Number(row.descriptionTotal) || 0);
                    }

                    return acc + rowGrandTotal;
                }, 0);
                serviceSum += serviceGrandTotal;

                const quotedValuePerService = selectedProject.QuotedValue / Object.keys(groupedData).length;
                const grossProfit = quotedValuePerService - serviceGrandTotal;
                const gaExpenses = grossProfit * (GandATax / 100);
                const ebit = grossProfit - gaExpenses;
                const tax = grossProfit * (taxValue / 100);
                const netRevenue = ebit - tax;

                grossProfitSum += grossProfit;
                gaExpensesSum += gaExpenses;
                // ebitSum += ebit;
                taxSum += tax;
                netRevenueSum += netRevenue;
            });

            // Calculate net revenue percentage
            const netRevenuePct = selectedProject.QuotedValue > 0
                ? (netRevenueSum / selectedProject.QuotedValue) * 100
                : 0;

            setTotalServiceGrandTotal(serviceSum);
            setTotalGrossProfit(grossProfitSum);
            setTotalGAExpenses(gaExpensesSum);
            // setTotalEBIT(ebitSum);
            setTotalTax(taxSum);
            setTotalNetRevenue(netRevenueSum);
            setNetRevenuePercentage(netRevenuePct);
        }
    }, [groupedData, selectedProject.QuotedValue, GandATax, taxValue]);

    useEffect(() => {
        if (groupedData && Object.keys(groupedData).length > 0) {
            let hoursSum = 0;

            Object.values(groupedData).forEach(rows => {
                rows.forEach(row => {
                    // Only add hours for non-Hardware services
                    if (row.typeService !== "Hardware") {
                        hoursSum += row.totalHours || 0;
                    }
                });
            });

            setTotalHoursSum(hoursSum);
        }
    }, [groupedData]);

    const saveNoteToAPI = useCallback(async (typeService, projectID, noteText) => {

        try {
            dispatch(replaceProjectFinanceNotes({ id: projectID, ProjectFinanceNotes: noteText }));
        } catch (error) {
            console.error('Error saving note:', error);
        } finally {
            enqueueSnackbar("Notes Added Successfully", { variant: "success" });

        }
    }, [dispatch, enqueueSnackbar]);

    const handleNoteChange = useCallback((typeService, projectID, noteText) => {

        // Create a unique key for this project-service combination
        const noteKey = `${projectID}-${typeService}`;

        // Update local state immediately for responsive UI
        setNotes(prev => ({
            ...prev,
            [noteKey]: noteText
        }));

        // Clear existing timeout for this noteKey
        if (saveTimeout[noteKey]) {
            clearTimeout(saveTimeout[noteKey]);
        }

        // Set new timeout for API call (debounce of 1 second)
        const newTimeout = setTimeout(() => {
            saveNoteToAPI(typeService, projectID, noteText);
        }, 2000);

        // Update timeout reference
        setSaveTimeout(prev => ({
            ...prev,
            [noteKey]: newTimeout
        }));
    }, [saveNoteToAPI, saveTimeout]);

    useEffect(() => {
        // Extract and set data for each service type with fallback to empty array
        setSoftwarePersons(groupedData.Software || []);
        setCloudPersons(groupedData.Cloud || []);
        setHardwarePersons(groupedData.Hardware || []);
        setinstallationPersons(groupedData.Installation || []);

    }, [groupedData, setSoftwarePersons, setCloudPersons, setHardwarePersons, setinstallationPersons]);
    return (
        <div className="pt-10 bg-white rounded-md">

            <div className="text-lg flex gap-2 font-semibold mb-2 pl-2">
                <h2 className="capitalize">Project Cost: {selectedProject.ProjectName}</h2>
                <button
                    onClick={handleClick}
                    className="flex items-center space-x-2 focus:outline-none"
                >
                    {/* Circle */}
                    <span
                        className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected ? "border-blue-600" : "border-gray-400"
                            }`}
                    >
                        {selected && <span className="w-3 h-3 bg-blue-600 rounded-full"></span>}
                    </span>

                    {/* Label */}
                    <span
                        className={`text-base font-medium ${selected ? " font-semibold" : "text-gray-600"
                            }`}
                    >
                        Itemized P&amp;L
                    </span>
                </button>
            </div>

            <div
                ref={tableContainerRef}
                style={{ scrollBehavior: 'smooth' }}
                className="maintable w-full overflow-auto">
                <div className="w-full flex text-xs font-semibold">
                    <div className="flex-shrink-0 first-line:flex flex justify-start  align-middle items-center p-4 border text-centestartr w-52 bg-[#E8E8E8] ">
                        Resources Designation
                    </div>
                    <div className="flex flex-shrink-0 justify-center  align-middle items-center p-4 border text-center w-40 bg-[#E8E8E8] ">
                        Hours
                    </div>
                    <div className="flex flex-shrink-0 justify-center  align-middle items-center p-4 border text-center  w-40 bg-[#E8E8E8] ">
                        Hourly Rate({currency}/hr)
                    </div>
                    <div className="flex flex-col flex-shrink-0 justify-center align-middle items-center p-4 border text-center w-40 bg-[#E8E8E8]">
                        Total Efforts({currency})
                        <br />
                        <p className="text-[12px]">(Hours * Hourly Rate)</p>
                    </div>
                    <div className="flex flex-shrink-0 justify-center  align-middle items-center p-4 border text-center w-40 bg-[#E8E8E8]">
                        Associated Cost({currency})
                    </div>
                    <div className="flex flex-col flex-shrink-0 justify-center  align-middle items-center p-3 border text-center w-40 bg-[#E8E8E8] ">
                        Total Cost({currency})
                        <br />
                        <p className="text-[12px]">(Total Efforts + Associated Cost)</p>
                    </div>
                    <div className="flex flex-shrink-0 justify-center  align-middle items-center p-4 border text-center w-40 bg-[#E8E8E8] ">
                        Total Cost Per Service({currency})
                    </div>
                    {selected && (
                        <div className="flex border">
                            <div className="flex-shrink-0 w-40 p-4 gap-2 flex justify-center align-middle items-center text-center border tracking-wider capitalize bg-[#E8E8E8]">
                                Quoted Price({currency})
                            </div>

                            <div className="flex-shrink-0 w-40 p-4 flex justify-center align-middle items-center text-center border tracking-wider capitalize bg-[#E8E8E8]">
                                Gross Profit({currency})
                            </div>
                            <div className="flex-shrink-0 w-40 p-4 flex justify-center align-middle items-center text-center border tracking-wider capitalize bg-[#E8E8E8]">
                                G&A Expenses({currency})
                            </div>
                            {/* <div className="flex-shrink-0 w-24 p-4flex justify-center align-middle items-center text-center border border-black tracking-wider capitalize bg-[#1973eb] text-white">
                        EBIT ({currency})
                      </div> */}
                            <div className="flex-shrink-0 w-24 p-4 flex justify-center align-middle items-center text-center border tracking-wider capitalize bg-[#E8E8E8]">
                                Tax({currency})
                            </div>
                            <div className="flex-shrink-0 w-52 flex flex-col justify-center align-middle items-center text-center border tracking-wider capitalize bg-[#E8E8E8]">
                                <div className="h-[50%] w-full flex justify-center align-middle items-center"> Net Revenue</div>
                                <div className="h-[50%] flex w-full">
                                    <div className="w-[50%] border flex justify-center align-middle items-center">({currency})</div>
                                    <div className="w-[50%] border flex justify-center align-middle items-center">(%)</div>
                                </div>

                            </div>
                            <div className="flex-shrink-0 w-24 p-4 flex justify-center align-middle items-center text-center border text-xs tracking-wider capitalize bg-[#E8E8E8]">
                                Notes
                            </div>
                        </div>
                    )}
                </div>

                <div className="Employee_Efforts_Calculation w-auto">
                    {Object.entries(groupedData)
                        // move Hardware last
                        .sort(([a], [b]) => {
                            if (a?.toLowerCase().includes("hardware")) return 1;
                            if (b?.toLowerCase().includes("hardware")) return -1;
                            return 0;
                        })
                        .map(([typeService, rows], serviceIndex) => {
                            // 👉 calculate subtotal for this service
                            const isHardware = typeService?.toLowerCase().includes("hardware");
                            const hasManager = rows.some(row => {
                                const role = row.roles[0]?.toLowerCase();
                                return role?.includes("manager") || role?.includes("project manager") || role?.includes("pm");
                            });
                            const serviceGrandTotal = rows.reduce(
                                (acc, row, idx) => {
                                    let rowGrandTotal = Number(row.grandTotal) || 0;

                                    // If hardware, no manager, and this is the first employee, include hardwareTotal
                                    if (isHardware && !hasManager && idx === 0) {
                                        rowGrandTotal = (Number(row.hardwareTotal) || 0) + (Number(row.descriptionTotal) || 0);
                                    }

                                    return acc + rowGrandTotal;
                                },
                                0
                            );

                            // Determine background color based on even/odd index
                            // const backgroundColor = serviceIndex % 2 === 0 ? "bg-white" : "bg-[#d9e0ef]";

                            return (
                                <div key={typeService} className="flex flex-col">
                                    <div className={`flex text-xs `}>
                                        <div className="border-b">
                                            {(() => {
                                                // Group rows by manager
                                                const groupedByManager = {};
                                                let currentManager = null;
                                                let managerCounter = 0;

                                                // First pass: group employees under their managers
                                                rows.forEach((row) => {
                                                    const role = row.roles[0]?.toLowerCase();

                                                    if (role?.includes("manager") || role?.includes("project manager") || role?.includes("pm")) {
                                                        // This is a manager - start a new group
                                                        managerCounter++;
                                                        currentManager = `manager${managerCounter}`;
                                                        groupedByManager[currentManager] = {
                                                            manager: row,
                                                            employees: []
                                                        };
                                                    } else if (currentManager) {
                                                        // This is an employee - add to current manager's group
                                                        groupedByManager[currentManager].employees.push(row);
                                                    } else {
                                                        // No manager found yet, create a default group
                                                        if (!groupedByManager.default) {
                                                            groupedByManager.default = {
                                                                manager: null,
                                                                employees: []
                                                            };
                                                        }
                                                        groupedByManager.default.employees.push(row);
                                                    }
                                                });

                                                // Second pass: render all groups
                                                const renderedRows = [];
                                                Object.entries(groupedByManager).forEach(([managerKey, group]) => {
                                                    let employeeCounter = 0;
                                                    let operationsCounter = 0;

                                                    // Render manager first (if exists)
                                                    if (group.manager) {
                                                        const managerNumber = managerKey.replace('manager', '');
                                                        renderedRows.push(
                                                            <div key={`${managerKey}-manager`} className={`flex `}>
                                                                <div className="w-52 py-1 px-4 capitalize flex-shrink-0 flex justify-start items-center text-start">
                                                                    {`${typeService} Manager ${managerNumber}`}
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center">
                                                                    {typeService?.toLowerCase().includes("hardware") ? "" : formatHours(group.manager.totalHours)}
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center">
                                                                    {typeService?.toLowerCase().includes("hardware") ? "" : formatMoneyComma(group.manager.hourlyRate)}
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center">
                                                                    {typeService?.toLowerCase().includes("hardware")
                                                                        ? formatMoneyComma(group.manager.hardwareTotal)
                                                                        : formatMoneyComma(group.manager.totalCost)
                                                                    }
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center">
                                                                    {formatMoneyComma(group.manager.descriptionTotal)}
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center">
                                                                    {formatMoneyComma(group.manager.grandTotal)}
                                                                </div>
                                                            </div>
                                                        );
                                                    }

                                                    // Render employees under this manager
                                                    group.employees.forEach((employee, idx) => {
                                                        const role = employee.roles[0]?.toLowerCase();
                                                        let displayText = '';

                                                        if (role === "operations") {
                                                            operationsCounter++;
                                                            displayText = `${typeService} Employee ${operationsCounter}`;
                                                        } else {
                                                            employeeCounter++;
                                                            displayText = `${typeService} Employee ${employeeCounter}`;
                                                        }

                                                        // Check if hardware service, no manager, and this is the first employee
                                                        const isHardwareNoManager = typeService?.toLowerCase().includes("hardware") && !group.manager;
                                                        const isFirstEmployee = idx === 0;
                                                        const shouldShowHardwareValue = isHardwareNoManager && isFirstEmployee;

                                                        // Calculate grandTotal: if hardware, no manager, and first employee, include hardwareTotal
                                                        const calculatedGrandTotal = shouldShowHardwareValue
                                                            ? (employee.hardwareTotal || 0) + (employee.descriptionTotal || 0)
                                                            : employee.grandTotal;

                                                        renderedRows.push(
                                                            <div key={`${managerKey}-employee-${idx}`} className={`flex `}>
                                                                <div className="w-52 py-1 px-4  capitalize flex-shrink-0 flex justify-start items-center text-start ">
                                                                    {displayText}
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center ">
                                                                    {typeService?.toLowerCase().includes("hardware") ? "" : formatHours(employee.totalHours)}
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center ">
                                                                    {typeService?.toLowerCase().includes("hardware") ? "" : formatMoneyComma(employee.hourlyRate)}
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center">
                                                                    {typeService?.toLowerCase().includes("hardware")
                                                                        ? (shouldShowHardwareValue ? formatMoneyComma(employee.hardwareTotal) : "")
                                                                        : formatMoneyComma(employee.totalCost)
                                                                    }
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center">
                                                                    {formatMoneyComma(employee.descriptionTotal)}
                                                                </div>
                                                                <div className="w-40 py-1 px-4  flex-shrink-0 flex justify-center items-center text-center">
                                                                    {formatMoneyComma(calculatedGrandTotal)}
                                                                </div>
                                                            </div>
                                                        );
                                                    });
                                                });

                                                return renderedRows;
                                            })()}
                                        </div>

                                        {/* 👉 Service Grand Total column (visible on larger screens) */}
                                        <div className={`grandTotal w-40 flex-shrink-0 py-1 px-4 border-b hidden md:flex justify-center align-middle items-center text-center  `}>
                                            {formatMoneyComma(serviceGrandTotal)}
                                        </div>

                                        {selected && (
                                            <div className={`flex `}>

                                                <div className="w-40 flex-shrink-0 py-1 px-4  border-b text-wrap truncate break-all flex justify-center align-middle items-center text-center">
                                                    {USAComma(rows[0]?.ServiceQuotedValue)}
                                                </div>


                                                {/* Gross Profit */}
                                                <div className={`w-40 flex-shrink-0 py-1 px-4  border-b flex justify-center items-center text-center text-wrap truncate break-all
                  ${calculateGrossProfit(selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) < 0 ? "text-red-500" : "text-black"}`}>
                                                    {USAComma(calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID))}
                                                </div>

                                                {/* G&A Expenses */}
                                                <div className={`w-40 flex-shrink-0 py-1 px-4  border-b flex justify-center items-center text-center text-wrap truncate break-all
                  ${calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (GandATax / 100) < 0 ? "text-red-500" : "text-black"}`}>
                                                    {USAComma(calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (GandATax / 100))}
                                                </div>

                                                {/* Tax */}
                                                <div className={`w-24 flex-shrink-0 py-1 px-4 border-b  flex justify-center items-center text-center text-wrap truncate break-all 
                  ${calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (taxValue / 100) < 0 ? "text-red-500" : "text-black"} `}>
                                                    {USAComma(calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (taxValue / 100))}
                                                </div>

                                                {/* Net Revenue */}
                                                <div className="w-52 flex-shrink-0  flex justify-center items-center border-b text-center text-wrap truncate break-all">
                                                    <div className={`w-[50%] h-full  flex justify-center items-center text-start 
                    ${((calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) - (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (GandATax / 100))) - (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (taxValue / 100))) < 0 ? "text-red-500" : "text-black"} `}>
                                                        {USAComma(
                                                            (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) -
                                                                (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (GandATax / 100))) -
                                                            (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (taxValue / 100))
                                                        )}
                                                    </div>
                                                    <div className={`w-[50%] h-full  flex justify-center items-center text-center 
                    ${(
                                                            ((
                                                                (
                                                                    (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) - (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (GandATax / 100)))
                                                                    - (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (taxValue / 100))
                                                                ) /
                                                                rows[0]?.ServiceQuotedValue) * 100
                                                            ).toFixed(2)
                                                        ) < 0 ? "text-red-500" : (
                                                            ((
                                                                (
                                                                    (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) - (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (GandATax / 100)))
                                                                    - (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (taxValue / 100))
                                                                ) /
                                                                rows[0]?.ServiceQuotedValue) * 100
                                                            ).toFixed(2)
                                                        ) < 10 ? "text-orange-600" : "text-black"
                                                        } `}>
                                                        {(
                                                            ((
                                                                (
                                                                    (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) - (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (GandATax / 100)))
                                                                    - (calculateGrossProfit(rows[0].ServiceQuotedValue, selectedProject.ProjectName, serviceGrandTotal, typeService, rows[0]?.ProjectID) * (taxValue / 100))
                                                                ) /
                                                                (rows[0].ServiceQuotedValue)) * 100

                                                            ).toFixed(2)
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Notes Input */}
                                                <div className="w-24 flex-shrink-0 py-1 px-4  border-b  flex justify-center items-start text-center text-wrap truncate break-all">
                                                    <textarea
                                                        className={`noteinput w-24 h-full outline-none text-center break-words whitespace-normal resize-none overflow-x-hidden`}
                                                        value={notes[`${rows[0]?.ProjectID}-${typeService}`] ?? rows[0]?.ProjectNotes ?? ''}
                                                        onChange={(e) => handleNoteChange(typeService, rows[0]?.ProjectID, e.target.value)}
                                                        placeholder="Enter Notes"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                </div>

                <div className="Totaltable flex w-full text-start text-sm font-semibold">
                    <div className="flex-shrink-0   py-1 px-4 border-b text-start  w-52 ">
                        Total
                    </div>

                    <div className="flex-shrink-0  py-1 px-4 border-b text-center w-40 ">
                        {formatHours(totalHoursSum)}
                    </div>
                    <div className="flex-shrink-0   py-1 px-4 border-b text-center w-40 ">
                        <div className="flex justify-around items-center"></div>
                    </div>

                    <div className="flex-shrink-0  py-1 px-4 border-b text-center w-40">
                        {formatMoneyComma(totalCostSum + matchedHardware)}
                    </div>
                    <div className="descriptionvaluetotal  py-1 px-4 border-b flex-shrink-0 p-1 text-center w-40">
                        {formatMoneyComma(matchedDescription)}
                    </div>
                    <div className="alltotal flex-shrink-0 py-1 px-4 border-b  text-center w-40 ">
                        {formatMoneyComma(totalServiceGrandTotal)}
                    </div>
                    <div className="sumOFserviceGrandTotal flex-shrink-0 py-1 px-4  border-b  text-center w-40">
                        {USAComma(roundedTotalCostPerService)}
                    </div>
                    {selected && (
                        <div className="flex">
                            <div className="alltotal flex-shrink-0 py-1 px-4 border-b  text-center w-40 ">
                                {/* {USAComma(
                                    Object.values(groupedData).reduce((total, rows) => {
                                        const serviceKey = `${rows[0]?.ProjectID}-${rows[0]?.typeService}`;
                                        const quotedValue = quotedValues[serviceKey] !== undefined
                                            ? parseFloat(quotedValues[serviceKey]) || 0
                                            : rows[0]?.ServiceQuotedValue || 0;
                                        return total + quotedValue;
                                    }, 0)
                                )} */}

                                {USAComma(selectedProject.QuotedValue)}

                            </div>
                            <div className={`sumofGrossProfit flex-shrink-0 py-1 px-4  border-b  text-center w-40  ${totalGrossProfit < 0 ? "text-red-500" : "text-black"
                                }`}>
                                {USAComma(totalGrossProfit)}
                            </div>
                            <div className={`sumofGAExpenses flex-shrink-0 py-1 px-4  border-b  text-center w-40  ${totalGAExpenses < 0 ? "text-red-500" : "text-black"
                                }`}>
                                {USAComma(totalGAExpenses)}
                            </div>
                            {/* <div className={`sumofEBIT flex-shrink-0 p-1 border border-black text-center w-24 bg-[#e7ebfb] ${totalEBIT < 0 ? "text-red-500" : "text-black"
                        }`}>
                        {USAComma(totalEBIT)}
                      </div> */}
                            <div className={`sumofTax flex-shrink-0 py-1 px-4  border-b text-center w-24  ${totalTax < 0 ? "text-red-500" : "text-black"
                                }`}>
                                {USAComma(totalTax)}
                            </div>
                            <div className="sumofNetRevenue flex flex-shrink-0  border-b text-center w-52 ">
                                <div className={`w-[50%] h-full   flex justify-center items-center text-center ${totalNetRevenue < 0 ? "text-red-500" : "text-black"
                                    }`}>
                                    {USAComma(totalNetRevenue)}
                                </div>
                                <div className={`w-[50%] h-full   flex justify-center items-center text-center ${netRevenuePercentage < 0 ? "text-red-500" :
                                    netRevenuePercentage < 10 ? "text-orange-600" : "text-black"
                                    }`}>
                                    {netRevenuePercentage.toFixed(2)}
                                </div>
                            </div>
                            <div className="alltotal flex-shrink-0 py-1 px-4  border-b text-center w-24 ">
                            </div>
                        </div>
                    )}
                </div>
            </div>


        </div>
    )
}

export default ActualAllServiceTable